'use client';

/**
 * Robot Manager 数据导入页（M1: 仅 PO tab；M2+ 加 RobotUnit / 主数据 / 售后）
 * 详见 docs/modules/robot-manager/14-import-export-tool-prd.md §4 (UX) / §8 (Wizard)
 */
import { useState } from 'react';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Badge } from '@/components/ui/badge';
import { useTranslation } from '@/hooks/useTranslation';

import { ImportWizard } from './_components/ImportWizard';

type TabKey = 'purchase-order' | 'robot-unit' | 'master' | 'service-ticket';

export default function RobotManagerImportPage() {
  const { t } = useTranslation();
  const im = t.robotManager.import;
  const [tab, setTab] = useState<TabKey>('purchase-order');

  return (
    <div className="p-6">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold">{im.pageTitle}</h1>
        <p className="text-sm text-muted-foreground">{im.pageSubtitle}</p>
      </header>

      <Tabs value={tab} onValueChange={(v) => setTab(v as TabKey)}>
        <TabsList>
          <TabsTrigger value="purchase-order">{im.tabs.purchaseOrder}</TabsTrigger>
          <TabsTrigger value="robot-unit" disabled>
            {im.tabs.robotUnit} <Badge variant="outline" className="ml-2">{im.comingSoon}</Badge>
          </TabsTrigger>
          <TabsTrigger value="master" disabled>
            {im.tabs.master} <Badge variant="outline" className="ml-2">{im.comingSoon}</Badge>
          </TabsTrigger>
          <TabsTrigger value="service-ticket" disabled>
            {im.tabs.serviceTicket} <Badge variant="outline" className="ml-2">{im.comingSoon}</Badge>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="purchase-order" className="mt-6">
          <ImportWizard type="purchase-order" typeLabel={im.tabs.purchaseOrder} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
